var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 178,
    viewBox: "0 0 1512 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149804_16659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33.8856 73.9148C-33.8856 73.9148 135.114 148.78 439.341 131.734C695.16 117.401 943.121 -29.8781 1257.68 49.1776C1409.57 87.3515 1624.86 208.661 1624.86 208.661",
    stroke: "#BBF2CE",
    strokeWidth: 32,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.19 73.914C1528.19 73.914 1359.19 148.779 1054.96 131.733C799.142 117.4 551.181 -29.8788 236.622 49.1769C84.73 87.3507 -130.553 208.66 -130.553 208.66",
    stroke: "#BBF2CE",
    strokeWidth: 32,
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149804_16659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 178,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccent);
export default __webpack_public_path__ + "static/media/Accent.5c295a846459c7cfca1a259d6b562563.svg";
export { ForwardRef as ReactComponent };